// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-WJR9"};